import { render, staticRenderFns } from "./request-portfolio.vue?vue&type=template&id=623dd590&lang=pug&"
import script from "./request-portfolio.vue?vue&type=script&lang=js&"
export * from "./request-portfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports